/**********************************************************************
 * src/components/Forms/AddRubrica.jsx
 *********************************************************************/
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../services/api'
import '../../css/addRubrica.css'

const AddRubrica = () => {
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    name: '',
    notes: '',
  })

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess('')

    if (!formData.name.trim()) {
      setError('Il nome è obbligatorio')
      return
    }

    setIsSubmitting(true)
    try {
      await api.post('/rubrica', formData, {
        headers: { 'Content-Type': 'application/json' },
      })
      setSuccess('Rubrica aggiunta con successo!')
      setFormData({
        name: '',
        notes: '',
      })
    } catch (err) {
      console.error("Errore nell'aggiunta della rubrica:", err)
      const msg = err?.response?.data?.error || "Errore nell'aggiunta della rubrica"
      setError(msg)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="addrubrica-container">
      <h2>Aggiungi Rubrica</h2>

      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}

      <form onSubmit={handleSubmit} className="addrubrica-form">
        <label>
          Titolo: <span className="required">*</span>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Titolo della rubrica"
          />
        </label>

        <label>
          Descrizione:
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder="Descrizione (opzionale)"
          />
        </label>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Salvataggio...' : 'Aggiungi Rubrica'}
        </button>
      </form>

      {success && (
        <button onClick={() => navigate('/dashboard')} className="redirect-btn">
          Vai alla Dashboard
        </button>
      )}
    </div>
  )
}

export default AddRubrica
